/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'suitcase-icon': {
    width: 22,
    height: 19,
    viewBox: '0 0 22 19',
    data: '<path pid="0" d="M15.212 3.475V1.709A1.7 1.7 0 0013.525 0H7.499C6.569 0 5.81.767 5.81 1.71l-.05 1.815H2.508C1.18 3.525.1 4.619.1 5.963v5.044a.62.62 0 00.616.625l7.624.05v1.573a.62.62 0 00.617.625h3.108a.62.62 0 00.617-.625l.05-1.623h7.573a.62.62 0 00.617-.625l-.001-5.044c0-1.344-1.08-2.438-2.407-2.438l-3.303-.05zM7.5 1.249h6.025c.252 0 .455.206.455.46l-.05 1.816-6.886-.05V1.709c0-.254.204-.46.456-.46zm3.952 11.332H9.624V9.408h1.827v3.173zM8.958 8.135a.62.62 0 00-.617.624l-.05 1.624-6.957-.05v-4.37c0-.655.526-1.188 1.175-1.188h16.007c.648 0 1.175.533 1.175 1.189l-.05 4.418-6.958-.05V8.76a.62.62 0 00-.617-.624H8.958zm11.348 4.845a.72.72 0 01.716.725v2.347c0 1.4-1.125 2.538-2.508 2.538H2.507C1.124 18.59 0 17.45 0 16.052v-2.347c0-.4.321-.725.716-.725a.72.72 0 01.717.725v2.347c0 .6.483 1.088 1.075 1.088h16.007c.593 0 1.075-.488 1.075-1.088v-2.347c0-.4.32-.725.716-.725z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
